export const PASSWORD_RESET_PATH_PREFIX = '/password-reset/';
export const DIGITAL_JOURNAL_PATH_PREFIX = '/digital-journal/';

// These routes carry a credential in the URL (a reset token in the path, a journal resend token
// in the query). The third-party tags in GTM read the full URL, so GTM must never load on them.
const SENSITIVE_PATH_PREFIXES = [PASSWORD_RESET_PATH_PREFIX, DIGITAL_JOURNAL_PATH_PREFIX];

export const isSensitivePath = (pathname: string | null | undefined): boolean =>
	Boolean(pathname) && SENSITIVE_PATH_PREFIXES.some(prefix => pathname?.includes(prefix));

// Drops the whole query (not just `token`) so a renamed or added param cannot leak, and keeps
// the fragment so analytics still see in-page anchors.
const DIGITAL_JOURNAL_QUERY_PATTERN = /(\/digital-journal\/[^?#\s]*)\?[^#\s]*/g;

export const redactDigitalJournalQuery = (value: string): string =>
	value.replace(DIGITAL_JOURNAL_QUERY_PATTERN, '$1');

// For Datadog, whose RUM and Logs events both stamp the page URL and referrer on every event.
export const redactSensitiveUrl = (url: string): string =>
	redactDigitalJournalQuery(url.replace(/\/password-reset\/.+/, '/password-reset/REDACTED'));
